import React, { useEffect, useRef, useState } from "react";
import {
  Paper,
  makeStyles,
  Button,
  Box,
  Grid,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Divider,
  Checkbox,
  FormControl,
  FormLabel,
  useTheme,
} from "@material-ui/core";
import { useForm } from "react-hook-form";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { useDispatch, useSelector } from "react-redux";
import { createTrust } from "../../store/action";
import Notification from "../../components/Notification/Notification";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from '@material-ui/icons/Delete';
import history from "../../utils/HistoryUtils";
import GoogleClientAddress from "./googleClientAddress";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowX: "auto",
    padding: "6px",
    background: theme.palette.background.main
  },

  formControl: {
    width: "100%",
  },
  footerBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "24px",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  radioGroup: {
    flexDirection: "row",
  },
  hospitalBox: {
    padding: 8,
    width: "100%",
  },
  lightGray: {
    background: "#f4f5f6",
    width: "100%",
    margin: 0,
    // padding: "16px 12px",
  },
  wardBox: {
    margin: 0,
    width: "100%",
    position: "relative",
  },

  addWards: {
    fontSize: 12,
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    "& .MuiButton-label": {
      display: "flex",
      alignItems: "center",
    },
    "& .MuiSvgIcon-root": {
      width: 18,
      height: "auto",
    },
  },
  removeWard: {
    position: "absolute",
    top: 24,
    right: 24,
    cursor: "pointer",
  },
  removeTraining: {
    position: "absolute",
    top: 24,
    right: "20px",
    cursor: "pointer",
  },
  removehospital: {
    position: "absolute",
    top: -9,
    right: -9,
    cursor: "pointer",
    background: "#ff8b46",
    borderRadius: "50%",
    width: 26,
    height: 26,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      fontSize: 16,
    },
  },
  showError: {
    color: "red",
  },
  disFeild: {
    color: "#757575",
  },
}));
function getSteps() {
  return ['Basic Information', 'Sites & Wards', 'Biling detail & Contact Information'];
}


const CreateTrust = () => {
  const classes = useStyle();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { createTrustError, createTrustSuccess } = useSelector(
    (state) => state.trust
  );
  const [trustNotify, setTrustNotify] = useState(false);
  const [addAnother, setAddAnother] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const {
    register,
    handleSubmit,
    // formState: { errors },
    reset,
  } = useForm();
  const [data, setData] = useState({
    name: "",
    code: "",
    preference_invoice_method: "",
    email_address: "",

    address_line_1: "",
    address_line_2: "",
    city: "",
    post_code: "",
    trust_portal_url: "",
    portal_email: "",
    portal_password: "",
    contact: [
      {
        first_name: "",
        last_name: "",
        contact_email_address: "",
        phone_number: "",
        client: "",
        department: "",
      },
    ],
    framework: "",
    vat: "standard",
    llp_status: "outside LPP",
    llp_trust_code: "",
    cost_center_code: "",
    contract: "",
    cas_connect_no: "",
    awr: "",
    training: [
      {
        training_name: "",
      },
    ],

    hospital: [
      {
        hospital_name: "",
        client_type: "",
        charge_area: "",
        client_address: "",
        ward: [
          {
            ward_name: "",
            phone_number: "",
            ward_type_id: null,
            ward_type: "",
            ward_number: "",
          },
        ],
        latitude: "",
        longitude: ""
      },
    ],
    ward: [
      {
        ward_name: "",
        phone_number: "",
        ward_type_id: null,
        ward_type: "",
        ward_number: "",
      },
    ],
  });

  const handleChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const handleCheckboxClick = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setIsChecked(true);
      setData({ ...data, [event.target.name]: "Yes" });
    } else {
      setIsChecked(false);
      setData({ ...data, [event.target.name]: "No" });
    }
  };

  const handleChangeHospital = (index, event, key) => {
    data[key][index][event.target.name] = event.target.value;
    setData({ ...data });
  };

  const handleChangeWardOFHospital = (hIndex, wIndex, event) => {
    data.hospital[hIndex].ward[wIndex][event.target.name] = event.target.value;
    setData({ ...data });
  };

  const addTraining = () => {
    const trainingData = JSON.parse(JSON.stringify(data));
    trainingData.training.push({
      training_name: "",
    });
    setData(trainingData);
  };

  const removeTraining = (index) => {
    const trainingData = JSON.parse(JSON.stringify(data));
    if (trainingData.training.length > 1) {
      trainingData.training.splice(index, 1);
      setData(trainingData);
    }
  };

  const handleChangeContactInfo = (index, event, key) => {
    data[key][index][event.target.name] = event.target.value;
    setData({ ...data });
  };

  const addContactInfo = () => {
    const contactInfoData = JSON.parse(JSON.stringify(data));
    contactInfoData.contact.push({
      first_name: "",
      last_name: "",
      contact_email_address: "",
      phone_number: "",
      client: "",
      department: "",
    });
    setData(contactInfoData);
  };

  const removeContactInfo = (index) => {
    const contactInfoData = JSON.parse(JSON.stringify(data));
    if (contactInfoData.contact.length > 1) {
      contactInfoData.contact.splice(index, 1);
      setData(contactInfoData);
    }
  };

  const addHospital = (e, index) => {
    const hos = JSON.parse(JSON.stringify(data));
    hos.hospital.push({
      hospital_name: "",
      client_type: "",
      charge_area: "",
      client_address: "",
      ward: [
        {
          ward_name: "",
          phone_number: "",
          ward_type_id: "",
          ward_number: "",
        },
      ],
    });
    setData(hos);
  };

  const wards = (id) => {
    const wards1 = JSON.parse(JSON.stringify(data));
    wards1.hospital[id].ward.push({
      ward_name: "",
      phone_number: "",
      ward_type_id: "",
      ward_number: "",
    });
    setData(wards1);
  };

  const removehospital = (index) => {
    const hos = JSON.parse(JSON.stringify(data));
    if (hos.hospital.length > 1) {
      hos.hospital.splice(index, 1);
      setData(hos);
    }
  };

  const removeWards = (index, wIndex) => {
    const wards1 = JSON.parse(JSON.stringify(data));
    if (wards1.hospital[index].ward.length > 1) {
      wards1.hospital[index].ward.splice(wIndex, 1);
      setData(wards1);
    }
  };

  const submitData = async (e) => {
    if (addAnother === true) {
      dispatch(createTrust(data, addAnother));
    } else {
      dispatch(createTrust(data, addAnother));
    }
    setTrustNotify(true);
  };
  const backPage = () => {
    history.goBack();
  };
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const steps = getSteps();

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    const stepErrors = validateCurrentStep(activeStep);

    if (Object.keys(stepErrors).length > 0) {
      // Show errors and prevent moving to next step
      setErrors(stepErrors);

      // Optional: Scroll to first error
      const firstErrorField = document.querySelector('[error]');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    } else {
      let newSkipped = skipped;
      if (isStepSkipped(activeStep)) {
        newSkipped = new Set(newSkipped.values());
        newSkipped.delete(activeStep);
      }

      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped);
      setErrors({});

    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  const [errors, setErrors] = useState({});
  const validateCurrentStep = (step) => {
    const newErrors = {};

    if (step === 0) {
      // Validate Basic Information step
      if (!data.name) {
        newErrors.name = "Customer Name is required";
      }
      if (!data.code) {
        newErrors.code = "Customer Code is required";
      }
      if (!data.preference_invoice_method) {
        newErrors.preference_invoice_method = "Preferred Invoice Method is required";
      }
      // Add other validations for step 0 as needed
    }

    if (step === 1) {
      // Validate Sites & Wards step

      // Validate hospitals
      data.hospital.forEach((hospital, hIndex) => {
        if (!hospital.hospital_name) {
          newErrors[`hospital.${hIndex}.hospital_name`] = "Site Name is required";
        }

        // Validate wards for each hospital
        hospital.ward.forEach((ward, wIndex) => {
          if (!ward.ward_name) {
            newErrors[`hospital.${hIndex}.ward.${wIndex}.ward_name`] = "Ward Name is required";
          }
        });
      });
    }

    if (step === 2) {
      // Validate Billing detail & Contact Information step
      // Add validations for step 2 as needed
    }
    console.log(newErrors, "newErrors");
    return newErrors;
  }
  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <TextField
                id="name"
                label="Customer Name"
                variant="outlined"
                name="name"
                // {...register("name", {
                //   required: "The name field is required.",
                // })}
                // error={errors.name ? true : false}
                error={!!errors.name} // Use your custom errors state
                helperText={errors.name} // Use your custom errors state

                onChange={handleChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                id="code"
                label="Customer Code"
                variant="outlined"
                name="code"
                // value={data?.code}
                // {...register("code", {
                //   required: "Please enter code",
                // })}
                // error={errors.code ? true : false}
                error={!!errors.code} // Use your custom errors state
                helperText={errors.code} // Use your custom errors state
                onChange={handleChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                id="framework"
                label="Framework"
                variant="outlined"
                name="framework"
                error={errors.framework ? true : false}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} lg={3}>
              <TextField
                id="llp_trust_code"
                label="LPP Trust Code"
                variant="outlined"
                name="llp_trust_code"
                value={data?.llp_trust_code}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <TextField
                id="cost_center_code"
                label="Cost Center Code"
                variant="outlined"
                name="cost_center_code"
                value={data?.cost_center_code}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <TextField
                id="cas_connect_no"
                label="Cash Connect No"
                variant="outlined"
                name="cas_connect_no"
                value={data?.cas_connect_no}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <TextField
                id="contract"
                label="Contract"
                variant="outlined"
                name="contract"
                value={data?.contract}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <div>
                <Divider />
              </div>
            </Grid>
            <Grid item xs={12}>
              <Typography color="primary">Invoicing Address</Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                id="address_line_1"
                label="Address line 1"
                variant="outlined"
                name="address_line_1"
                onChange={handleChange}
                fullWidth
              // required
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                id="address_line_2"
                label="Address line 2"
                variant="outlined"
                name="address_line_2"
                value={data.address_line_2}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={3} >
              <TextField
                id="city"
                label="Town / City"
                variant="outlined"
                name="city"
                onChange={handleChange}
                fullWidth
              // required
              />
            </Grid>
            <Grid item xs={12} sm={3} >
              <TextField
                id="post_code"
                label="Postcode"
                variant="outlined"
                name="post_code"
                onChange={handleChange}
                fullWidth
              // required
              />
            </Grid>

            <Grid item xs={12} sm={3} >
              <TextField
                id="email_address"
                label="Customer Email"
                variant="outlined"
                name="email_address"
                onChange={handleChange}
                fullWidth
              // required
              />
            </Grid>
            <Grid xs={12} sm={9}></Grid>
            <Grid item xs={12} sm={3}>
              <Box className="mt-1">
                <FormControl
                  required
                  error={!!errors.preference_invoice_method} // Check if error exists
                  // error={errors?.preference_invoice_method ? true : false}
                  component="fieldset"
                  className={classes.formControl}
                >
                  <FormLabel
                    component="legend"
                    style={{ color: theme.palette.grey[800] }}
                    className={
                      createTrustError &&
                        createTrustError.preference_invoice_method &&
                        createTrustError.preference_invoice_method[0]
                        ? classes.showError
                        : classes.disFeild
                    }
                  >
                    Preferred Invoice Method
                  </FormLabel>
                  <RadioGroup
                    name="preference_invoice_method"
                    onChange={handleChange}
                    className={classes.radioGroup}
                  >
                    <FormControlLabel
                      value="BYPost"
                      control={<Radio />}
                      label="By Post"
                    />
                    <FormControlLabel
                      value="BYEmail"
                      control={<Radio />}
                      label="By Email"
                    />
                  </RadioGroup>
                  {errors.preference_invoice_method && (
                    <Typography className={classes.showError} variant="caption">
                      {errors.preference_invoice_method}
                    </Typography>
                  )}
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} sm={3} lg={3}>
              <Box className="mt-3">
                <Typography>VAT</Typography>
                <RadioGroup
                  name="vat"
                  value={data?.vat || ""}
                  onChange={handleChange}
                  className={classes.radioGroup}
                >
                  <FormControlLabel
                    value="standard"
                    control={<Radio />}
                    label="Standard"
                  />
                  <FormControlLabel
                    value="exempt"
                    control={<Radio />}
                    label="Exempt"
                  />
                </RadioGroup>
              </Box>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Box className="mt-3">
                <Typography>LLP Status</Typography>
                <RadioGroup
                  name="llp_status"
                  value={data?.llp_status || ""}
                  onChange={handleChange}
                  className={classes.radioGroup}
                >
                  <FormControlLabel
                    value="outside LPP"
                    control={<Radio />}
                    label="Outside LPP"
                  />
                  <FormControlLabel
                    value="inside LPP"
                    control={<Radio />}
                    label="Inside LPP"
                  />
                </RadioGroup>
              </Box>
            </Grid>
            <Grid item xs={12} sm={3} >
              <Box style={{ marginTop: "20px" }}>
                <Checkbox
                  checked={isChecked}
                  label="AWR"
                  name="awr"
                  value={data?.awr}
                  // onChange={handleChange}
                  onClick={(event) => handleCheckboxClick(event)}
                  className="mt-2"
                />{" "}
                AWR
              </Box>
            </Grid>
          </Grid >
        );
      case 1:
        return (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography color="primary" >Portal Login Detail</Typography>
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <TextField
                  id="trust_portal_url"
                  label="Customer Portal URl"
                  variant="outlined"
                  name="trust_portal_url"
                  onChange={handleChange}
                  fullWidth
                // required
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <TextField
                  id="portal_email"
                  label="Email Address"
                  variant="outlined"
                  name="portal_email"
                  autoComplete="new-password"
                  onChange={handleChange}
                  fullWidth
                // required
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <TextField
                  id="portal_password"
                  type="password"
                  label="Password"
                  variant="outlined"
                  name="portal_password"
                  autoComplete="new-password"
                  onChange={handleChange}
                  fullWidth
                // required
                />
              </Grid>
              <Grid item xs={12}>
                <div className="pt-5 pb-4">
                  <Divider />
                </div>
              </Grid>
              <Box sx={{
                border: "1px solid #ddd", // Light gray border
                borderRadius: "8px",
                padding: "16px",
                backgroundColor: theme.palette.background.main,
              }}>
                {data.hospital.map((item, index) => {
                  return (
                    <div className={classes.hospitalBox} key={index}>
                      <Grid
                        container
                        spacing={2}
                        // className={classes.lightGray}
                        style={{ position: "relative" }}
                      >
                        <Grid item xs={3}>
                          <TextField
                            id="hospital_name"
                            label="Site Name"
                            variant="outlined"
                            name="hospital_name"
                            value={item?.hospital_name || ""}
                            // error={
                            //   errors.trust_portal_url
                            //     ? true
                            //     : createTrustError &&
                            //       createTrustError?.[
                            //       `hospital.${index}.hospital_name`
                            //       ]
                            //       ? true
                            //       : false
                            // }
                            error={!!errors[`hospital.${index}.hospital_name`]} // Check if error exists
                            helperText={errors[`hospital.${index}.hospital_name`]} // Show error message
                            onChange={(e) =>
                              handleChangeHospital(index, e, "hospital")
                            }
                            fullWidth
                            required
                          />
                          {index !== 0 && (
                            <div className={classes.removehospital}>
                              <DeleteIcon onClick={() => removehospital(index)} />
                            </div>
                          )}
                        </Grid>
                        <Grid item xs={3}>
                          <TextField
                            id="client_type"
                            label="Client Type"
                            variant="outlined"
                            name="client_type"
                            value={item?.client_type || ""}
                            error={
                              errors.client_type
                                ? true
                                : createTrustError &&
                                  createTrustError?.[
                                  `hospital.${index}.client_type`
                                  ]
                                  ? true
                                  : false
                            }
                            onChange={(e) =>
                              handleChangeHospital(index, e, "hospital")
                            }
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <TextField
                            id="charge_area"
                            label="Charge Area"
                            variant="outlined"
                            name="charge_area"
                            value={item?.charge_area || ""}
                            error={
                              errors.charge_area
                                ? true
                                : createTrustError &&
                                  createTrustError?.[
                                  `hospital.${index}.charge_area`
                                  ]
                                  ? true
                                  : false
                            }
                            onChange={(e) =>
                              handleChangeHospital(index, e, "hospital")
                            }
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <GoogleClientAddress
                            item={item}
                            index={index}
                            register={register}
                            errors={errors}
                            createTrustError={createTrustError}
                            data={data}
                            setData={setData}
                          />
                        </Grid>

                        {item.ward.map((wardsField, wIndex) => {
                          return (
                            <Grid
                              container
                              spacing={2}
                              key={wIndex}
                              className={classes.wardBox}
                            >
                              <Grid item xs={12} sm={3}>
                                <TextField
                                  id="ward_name"
                                  label="Ward Name"
                                  variant="outlined"
                                  name="ward_name"
                                  value={wardsField?.ward_name}
                                  // {...register('ward_name', {
                                  //     required: "Please enter ward name",
                                  // })}
                                  // error={
                                  //   // (errors.ward_name ? true : (createTrustError && createTrustError?.message) ? (createTrustError?.message[`hospital.${index}.ward.${wIndex}.ward_name`] ? true :false) : false)
                                  //   errors.trust_portal_url
                                  //     ? true
                                  //     : createTrustError &&
                                  //       createTrustError?.[
                                  //       `hospital.${index}.ward.${wIndex}.ward_name`
                                  //       ]
                                  //       ? true
                                  //       : false
                                  // }
                                  error={!!errors[`hospital.${index}.ward.${wIndex}.ward_name`]} // Check if error exists
                                  helperText={errors[`hospital.${index}.ward.${wIndex}.ward_name`]} // Show error message
                                  onChange={(e) =>
                                    handleChangeWardOFHospital(index, wIndex, e)
                                  }
                                  fullWidth
                                  required
                                />
                              </Grid>
                              <Grid item xs={12} sm={3}>
                                <TextField
                                  id="ward_type"
                                  label="Ward Type"
                                  variant="outlined"
                                  name="ward_type"
                                  type="text"
                                  value={wardsField?.ward_type}
                                  error={
                                    errors.trust_portal_url
                                      ? true
                                      : createTrustError &&
                                        createTrustError?.[
                                        `hospital.${index}.ward.${wIndex}.ward_type`
                                        ]
                                        ? true
                                        : false
                                  }
                                  onChange={(e) =>
                                    handleChangeWardOFHospital(index, wIndex, e)
                                  }
                                  fullWidth
                                />
                              </Grid>
                              <Grid item xs={12} sm={3}>
                                <TextField
                                  id="phone_number"
                                  label="Phone Number"
                                  variant="outlined"
                                  name="phone_number"
                                  type="text"
                                  value={wardsField?.phone_number}
                                  error={
                                    errors.phone_number
                                      ? true
                                      : createTrustError &&
                                        createTrustError?.[
                                        `hospital.${index}.ward.${wIndex}.phone_number`
                                        ]
                                        ? true
                                        : false
                                  }
                                  onChange={(e) =>
                                    handleChangeWardOFHospital(index, wIndex, e)
                                  }
                                  fullWidth
                                />
                              </Grid>
                              {wIndex !== 0 ? (
                                <DeleteIcon
                                  className={classes.removeWard}
                                  onClick={() => removeWards(index, wIndex)}
                                />
                              ) : (
                                ""
                              )}
                            </Grid>
                          );
                        })}

                        <Grid item xs={12}>
                          <Button
                            onClick={() => wards(index)}
                            color="secondary"
                            className={classes.addWards}
                          >
                            <AddCircleOutlineIcon className="mr-3" />
                            <span>Add Wards</span>
                          </Button>
                        </Grid>
                      </Grid>
                    </div>
                  );
                })}

                <Grid item xs={12}>
                  <Button onClick={() => addHospital()} color="secondary">
                    <AddCircleOutlineIcon className="mr-3" />
                    <Typography>Add Site</Typography>
                  </Button>
                </Grid>
              </Box>

            </Grid>
          </>
        );
      case 2:
        return (
          <>
            <Grid container spacing={2}>

              <Grid container alignItems="center" justifyContent="space-between" style={{ padding: "10px" }}>
                <Grid item >
                  <Typography>Notes</Typography>
                </Grid>
                <Grid item >
                  <Button color="secondary" onClick={addTraining}>
                    <AddCircleOutlineIcon className="mr-3" />
                    <Typography>Add Notes </Typography>
                  </Button>
                </Grid>
              </Grid>

              {data.training.map((item, index) => {
                return (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    key={index}
                    style={{ position: "relative" }}
                  >
                    <TextField
                      id="training_name"
                      label="Notes"
                      variant="outlined"
                      name="training_name"
                      value={item?.training_name || ""}
                      onChange={(e) => handleChangeHospital(index, e, "training")}
                      fullWidth
                    />
                    {index !== 0 ? (
                      <DeleteIcon
                        className={classes.removeTraining}
                        onClick={() => removeTraining(index)}
                      />
                    ) : (
                      ""
                    )}
                  </Grid>
                );
              })}
              <Grid item xs={12} sm={6} lg={4}>
                {/* <Button color="secondary" onClick={addTraining}>
                  <AddCircleOutlineIcon className="mr-3" />
                  <Typography>Add Notes </Typography>
                </Button> */}
              </Grid>
              <Grid item xs={12}>
                <div className="pt-5 pb-4">
                  <Divider />
                </div>
              </Grid>
              <Grid item xs={12}>
                <Typography>Contact Information</Typography>
              </Grid>
              <Box sx={{
                border: "1px solid #ddd", // Light gray border
                borderRadius: "8px",
                padding: "16px",
                backgroundColor: theme.palette.background.main,
              }}>
                {data.contact.map((item, index) => {
                  return (
                    <Grid
                      container
                      spacing={2}
                      key={index}
                      className={classes.wardBox}
                    >
                      <Grid item xs={11}>
                        {index !== 0 && (
                          <div className="pt-5 pb-4">
                            <Divider />
                          </div>
                        )}
                      </Grid>
                      <Grid item xs={11} sm={11} lg={11}>
                        <Grid
                          container
                          spacing={2}
                          key={index}
                          className={classes.wardBox}
                        >
                          <Grid item xs={12} sm={6} lg={4}>
                            <TextField
                              id="first_name"
                              label="First Name"
                              variant="outlined"
                              name="first_name"
                              value={item.first_name}
                              onChange={(e) =>
                                handleChangeContactInfo(index, e, "contact")
                              }
                              fullWidth
                            // required
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <TextField
                              id="last_name"
                              label="Last Name"
                              variant="outlined"
                              name="last_name"
                              value={item.last_name}
                              onChange={(e) =>
                                handleChangeContactInfo(index, e, "contact")
                              }
                              fullWidth
                            // required
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <TextField
                              id="contact_email_address"
                              label="Email"
                              variant="outlined"
                              name="contact_email_address"
                              value={item.contact_email_address}
                              onChange={(e) =>
                                handleChangeContactInfo(index, e, "contact")
                              }
                              fullWidth
                            // required
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <TextField
                              id="phone_number"
                              label="Contact Number"
                              variant="outlined"
                              name="phone_number"
                              // type="number"
                              value={item.phone_number}
                              onChange={(e) =>
                                handleChangeContactInfo(index, e, "contact")
                              }
                              fullWidth
                            // required
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <TextField
                              id="client"
                              label="Client"
                              variant="outlined"
                              name="client"
                              value={item.client}
                              onChange={(e) =>
                                handleChangeContactInfo(index, e, "contact")
                              }
                              fullWidth
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <TextField
                              id="department"
                              label="Department"
                              variant="outlined"
                              name="department"
                              value={item.department}
                              onChange={(e) =>
                                handleChangeContactInfo(index, e, "contact")
                              }
                              fullWidth
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={1} sm={1} lg={1}>
                        {index !== 0 ? (
                          <DeleteIcon
                            className={classes.removeWard}
                            onClick={() => removeContactInfo(index)}
                          />
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  );
                })}
                <Grid item xs={12} sm={6} lg={4}>
                  <Button color="secondary" onClick={addContactInfo}>
                    <AddCircleOutlineIcon className="mr-3" />
                    <Typography>Add Contact Info</Typography>
                  </Button>
                </Grid>
              </Box>
            </Grid >
          </>
        );
      default:
        return 'Unknown step';
    }
  }
  return (
    <>
      {trustNotify && createTrustSuccess?.message && (
        <Notification data={createTrustSuccess?.message} status="success" />
      )}

      {trustNotify &&
        (createTrustError?.message?.code || createTrustError?.message) && (
          <Notification
            data={
              createTrustError?.message?.code
                ? createTrustError?.message?.code
                : createTrustError?.message
            }
            status="error"
          />
        )}
      {trustNotify &&
        (Object.values(createTrustError)?.length > 0 || createTrustError) && (
          <Notification
            data={Object.values(createTrustError)[0]}
            status="error"
          />
        )}
      <Paper className={classes.root}>
        <form onSubmit={handleSubmit(submitData)} autoComplete="off">
          <div >
            <Stepper activeStep={activeStep} style={{ background: "none" }}>
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                // if (isStepOptional(index)) {
                //   labelProps.optional = <Typography variant="caption">Optional</Typography>;
                // }
                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}
                      sx={{
                        '& .MuiStepLabel-label': {
                          color: theme.palette.listItem,
                          // fontWeight: 600,
                          // fontSize: '0.95rem',
                        }
                      }}
                    >
                      <span style={{
                        color: theme.palette.listItem,
                      }}>{label}</span></StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            <div>
              {activeStep === steps.length ? (
                <div>
                  <Typography className={classes.instructions}>
                    All steps completed - you&apos;re finished
                  </Typography>
                  <Button onClick={handleReset} className={classes.button}>
                    Reset
                  </Button>
                </div>
              ) : (
                <div>
                  <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px", marginBottom: "15px" }}>
                    <div>
                      <Button
                        variant="contained"
                        color="primary" onClick={() => history.goBack(-1)} className={classes.button}>
                        Cancel
                      </Button>
                    </div>
                    <div style={{ display: "flex" }}>
                      <Button disabled={activeStep === 0} onClick={handleBack} className={classes.button}>
                        Back
                      </Button>


                      {activeStep !== steps.length - 1 && (
                        <Button
                          style={{ marginRight: "5px" }}
                          variant="contained"
                          color="primary"
                          onClick={handleNext}
                          className={classes.button}
                        >
                          Next
                          {/* {activeStep === steps.length - 1 ? 'Finish' : 'Next'} */}
                        </Button>)}
                      {activeStep === steps.length - 1 &&
                        <>
                          {/* <Button variant="contained" className={classes.button}
                          color="primary" onClick={backPage}>
                          Cancel
                        </Button> */}
                          <Button
                            className={classes.button}
                            variant="contained"
                            color="primary"
                            type="submit"
                            name="btn1"
                            style={{ marginRight: "5px" }}
                            formNoValidate
                            onClick={() => setAddAnother(false)}
                          >
                            Save & Confirm
                          </Button>
                          <Button
                            className={classes.button}
                            variant="contained"
                            color="primary"
                            style={{ marginRight: "5px" }}
                            type="submit"
                            name="btn2s"
                            formNoValidate
                            onClick={() => setAddAnother(true)}
                          >
                            Save & Add another
                          </Button>
                        </>
                      }
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </form>
      </Paper>
    </>
  );
};

export default CreateTrust;
